<template lang="pug">
fieldset(:disabled="loading")
  modal(:active="active" title="Enviar CSV de importação" @close="$emit('close')")
    div(slot="modal-body" v-if="active")
      .my-2 Baixe o template de CSV #[a.text-warning(:href="templateURL" target="_blank") aqui]
      input.form-input(type="file" accept="text/csv" @change="onChangeFileInput")
    div(slot="modal-footer")
      button.btn.btn-primary(:disabled="!file" @click="onSubmit" :class="{loading}")
        i.fas.fa-upload
        |  Importar CSV
</template>

<script>
import importCsvs from '@/services/importCsvs'

export default {
  props: {
    active: { type: Boolean, required: true },
  },
  data() {
    return {
      file: null,
      loading: false,
    }
  },
  computed: {
    templateURL() {
      return importCsvs.downloadTemplateURL()
    },
  },
  methods: {
    async onSubmit() {
      try {
        const formData = new FormData()
        formData.append('file', this.file)
        const { data } = await importCsvs.importPeople(formData)
        this.$emit('uploaded', data)
        this.file = null
      } catch (e) {
        this.$toaster.error(e.message)
      }
    },
    onChangeFileInput(e) {
      this.file = e.target.files[0]
    },
  },
}
</script>
